import { render, staticRenderFns } from "./ManualReversalForm.vue?vue&type=template&id=bdb6a366&scoped=true&"
import script from "./ManualReversalForm.vue?vue&type=script&lang=js&"
export * from "./ManualReversalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb6a366",
  null
  
)

export default component.exports